import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-precipitation-svg',
  imports: [],
  templateUrl: './precipitation-svg.component.html',
  styleUrl: './precipitation-svg.component.css'
})
export class PrecipitationSvgComponent {
  @Input() width: string = '50'
  @Input() height: string = '50'
  @Input() online: boolean = false
}
